module.exports = __webpack_public_path__ + "img/7.8446f5dc.png";